"use client";
const i = (e) => e != null;
export {
  i as isDefined
};
